import React from "react";

interface Props {
  title: string;
  link?: string;
  imgSrc?: string;
  text: string;
  textAlign?: "left" | "center" | "right";
  justifyItems?: "start" | "between" | "end";
  highlight?: boolean;
}

const Card = ({
  title,
  link,
  imgSrc,
  text,
  textAlign = "center",
  justifyItems = "start",
  highlight = false
}: Props) => {
  return (
    <div
      className={`flex-1 bg-white p-4 rounded-t rounded-b-none overflow-hidden shadow ${
        highlight ? "border-solid border-2 border-yellow-500" : ""
      }`}
    >
      {link ? (
        <a
          href={link}
          className={`flex flex-wrap flex-col h-full justify-${justifyItems} no-underline hover:no-underline`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className={`w-full font-bold text-xl text-gray-800 text-center`}>
            {title}
            {highlight && (
              <span className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2">
                Neu
              </span>
            )}
          </div>
          {imgSrc && <img className="m-auto my-6" src={imgSrc} alt="" />}
          <p className={`w-full text-gray-800 text-base text-${textAlign}`}>
            {text}
          </p>
        </a>
      ) : (
        <div
          className={`flex flex-wrap flex-col h-full justify-${justifyItems}`}
        >
          {imgSrc && <img className="m-auto my-6 w-1/3" src={imgSrc} alt="" />}
          <div>
            <div
              className={`w-full font-bold text-xl text-gray-800 mb-6 text-center`}
            >
              {title}
              {highlight && (
                <span className="inline-block bg-yellow-500 rounded-full px-3 py-1 text-sm font-semibold text-gray-800 mx-2">
                  Jetzt Neu!
                </span>
              )}
            </div>
            <p className={`w-full text-gray-800 text-base text-${textAlign}`}>
              {text}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Card;
